import { Component, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RsLoaderComponent } from '@rs-shared-lib/components/rs-loader/components/rs-loader.component';
import { RsTopBarMenuComponent } from '@rs-shared-lib/components/topbar/rs-top-bar-menu.component';
import { RsFooterComponent } from '@rs-shared-lib/components/footer/rs-footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { UserService } from '@shared/services/user.service';
import { MenuItem } from '@rs-shared-lib/models';

@Component({
  imports: [
    RouterModule,
    RsLoaderComponent,
    RsTopBarMenuComponent,
    RsFooterComponent,
    TranslateModule
  ],
  selector: 'ord-admin-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  public readonly menuItems = signal<MenuItem[]>([]);
  private readonly userService = inject(UserService);

  constructor() {
    this.userService.fetchUser$.subscribe(() => {
      this.setTopBarMenu();
    });
  }

  private setTopBarMenu(): void {
    this.menuItems.set([this.getMainMenu(), this.getBatchesMenu()]);
  }

  private getMainMenu(): MenuItem {
    return{
      id: 'distribution-center',
      label: 'DISTRIBUTION_CENTER',
      baseMenuUrl: ['distribution-center'],
      subMenuItems: [
        {
          id: 'distribution-center-packages',
          label: 'PACKAGES',
          url: 'distribution-center/packages',
          display: this.userService.isCsUser()
        },
        {
          id: 'distribution-center-items',
          label: 'ITEMS',
          url: 'distribution-center/items',
          display: this.userService.isCsUser()
        },
        {
          id: 'distribution-center-package-orders',
          label: 'PACKAGE-ORDERS',
          url: 'distribution-center/package-orders',
        },
        {
          id: 'distribution-center-anomalies',
          url: 'distribution-center/anomalies',
          label: 'ANOMALIES',
        }
      ]
    }
  }

  private getBatchesMenu(): MenuItem {
    return {
      id: 'batch',
      label: 'BATCH',
      url: 'batch',
      display: this.userService.isCsUser(),
    };
  }

}
